module.exports = __webpack_public_path__ + "img/scale.f56d9500.svg";